import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { CSVLink } from "react-csv";
import Button from "components/Button";
import Select from "components/Select";
import Datepicker from "components/DatePicker";
import { allOrderReport, allUserOrderReport } from "actions/orders";
import { FilterWrapper } from "styles/pages/sales-report";
import DateRangeIcon from "@material-ui/icons/DateRange";
import { rows } from "pages/sales-report/table/rows";
import { calculateTax } from "actions/stripe";

const Filters = ({
  startDate,
  endDate,
  onChange,
  generateReport,
  data,
  group,
  groups,
  isAdmin,
}) => {
  const [taxInfo, setTaxInfo] = useState(null);
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);
  const dispatch = useDispatch();
  const csvEl = useRef(null);

  const [allOrderData, setAllOrderData] = useState(undefined);
  let disabled = !startDate || !endDate;
  if (startDate && endDate) {
    disabled = moment(moment(endDate).format("MM/DD/YYYY")).isBefore(
      moment(startDate).format("MM/DD/YYYY")
    );
  }

  useEffect(() => {
    const getData = async () => {
      const data = await dispatch(calculateTax());
      setTaxInfo(data);
    };

    if (!taxInfo) {
      getData();
    }
  }, [dispatch, taxInfo]);

  const csvData = [
    [
      "Production Submit Date",
      "Order Ship Date",
      "User Email",
      "Order#",
      "Shopify ID",
      "Order Line Items",
      "Color",
      "Size",
      "Quantity",
      "Line Items Cost (Without Tax)",
      // "Currency Code (Line Items Cost - Without Tax)",
      "Shipping Cost (Without Tax)",
      // "Currency Code (Shipping Cost - Without Tax)",
      "Total Tax in USD",
      "Total Amount Paid in USD",
      // "Total Amount Paid in CAD",
    ],
  ];

  if (allOrderData) {
    const dataTemp = rows(allOrderData, taxInfo);
    if (!!dataTemp?.length) {
      for (let i = 0; i < dataTemp?.length; i++) {
        const {
          orderSubmitToProductionDate,
          orderShipDate,
          masterUserEmail,
          ID,
          shopifyOrderPresentedID,
          lineItemsCost,
          shippingCostWithoutTax,
          totalTax,
          totalAmountPaidUsd,
          // totalAmountPaidCad,
          productName,
          color,
          size,
          quantity,
          // lineItemsCostCurrencyCode,
          // shippingCostCurrencyCode,
        } = dataTemp[i];

        csvData.push([
          orderSubmitToProductionDate,
          orderShipDate,
          masterUserEmail,
          ID,
          shopifyOrderPresentedID || "",
          productName,
          color,
          size,
          quantity,
          lineItemsCost,
          // lineItemsCostCurrencyCode,
          shippingCostWithoutTax,
          // shippingCostCurrencyCode,
          totalTax,
          totalAmountPaidUsd,
          // totalAmountPaidCad,
        ]);
      }
    }
  }

  return (
    <FilterWrapper>
      <Datepicker
        label="Start Date"
        value={startDate}
        onChange={(v) => onChange("startDate", v)}
      />
      <Datepicker
        label="End Date"
        value={endDate}
        onChange={(v) => onChange("endDate", v)}
      />
      {isAdmin && (
        <div style={{ width: 200 }}>
          <Select
            options={groups || []}
            label="Select Group"
            labelKey="name"
            value={group}
            onChange={(v) => onChange("group", v)}
          />
        </div>
      )}

      <Button
        title="Generate Report"
        disabled={disabled}
        onClick={() => {
          generateReport();
          setAllOrderData(undefined);
        }}
        containerStyle={{
          height: 20,
          padding: 20,
          backgroundColor: disabled ? "#CCCCCC" : "#000",
          color: "#FFFFFF",
        }}
      />

      {/* {data?.orders && (
        <SalesReportPdf
          data={data?.allOrders}
          startDate={startDate}
          endDate={endDate}
        />
      )} */}

      {data?.orders && (
        <DateRangeIcon
          onClick={async () => {
            let response;

            if (isAdmin) {
              response = await dispatch(
                allOrderReport({
                  startDate: moment(startDate).subtract(1, "days"),
                  endDate: moment(endDate).add(1, "days"),
                })
              );
            } else {
              response = await dispatch(
                allUserOrderReport({
                  startDate: moment(startDate).subtract(1, "days"),
                  endDate: moment(endDate).add(1, "days"),
                  user: emailid,
                })
              );
            }

            if (response?.error) {
              return;
            }
            setAllOrderData(response?.allOrders);

            setTimeout(() => {
              csvEl.current.link.click();
            }, 10);
          }}
          style={{ color: "green", fontSize: 36, cursor: "pointer" }}
        />
      )}

      {csvData && (
        <CSVLink
          style={{ display: "none" }}
          ref={csvEl}
          data={csvData}
          filename={`BOT_Sales_Report(${moment(startDate).format(
            "MMM DD YYYY"
          )} - ${moment(endDate).format("MMM DD YYYY")}).xls`}
        />
      )}
    </FilterWrapper>
  );
};

export default Filters;
